<div class="kpi-key">
  <span>&lt;=  20%</span><span>&gt; 20  to 40%</span><span>&gt; 40 to 60%</span><span>&gt; 60 to 80%</span><span>&gt; 80%</span>
</div>
